import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import useAuth from '../../dashboard/useAuth';
import ReactQuill from 'react-quill';  // Quill editor
import 'react-quill/dist/quill.snow.css';  // Quill styles
import { BsPeople } from 'react-icons/bs';

const Modifier_groupe = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const user_id = localStorage.getItem('user_id');
    const { groupe_id } = location.state || {}; // Récupérer l'ID du groupe à modifier
    const navigate = useNavigate(); // Fonction de redirection

    const [groupeData, setGroupeData] = useState({
        nom: '',
        description: '',
        statut: 'inactif',  // Initialisation du statut
    });
    const [originalGroupeData, setOriginalGroupeData] = useState({}); // Stockage des données originales

    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
      if (user_id) {
        document.title = "eTrainApp | Modifier groupe";
      }
    }, [user_id]);

    // Récupérer les données du groupe pour les afficher dans le formulaire
    useEffect(() => {
        const fetchGroupeData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/groupe-info/${groupe_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setGroupeData({
                        nom: data.nom,
                        description: data.description,
                        statut: data.statut,
                    });
                    setOriginalGroupeData({  // Stocker les données originales pour réinitialisation
                        nom: data.nom,
                        description: data.description,
                        statut: data.statut,
                    });
                } else {
                    console.error('Erreur lors de la récupération des données du groupe');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchGroupeData();
    }, [groupe_id]);

    // Fonction de soumission du formulaire
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = {
            nom: groupeData.nom,
            description: groupeData.description,
            statut: groupeData.statut,
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-groupe/${groupe_id}/`, {
                method: 'PUT', // Utilisation de PUT pour modifier le groupe
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                navigate(`/Liste-groupe`);  // Redirection vers la liste des groupes après modification
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Fonction pour réinitialiser les champs à leur état original
    const handleCancel = () => {
        setGroupeData(originalGroupeData); // Réinitialisation des données
    };

    // Configuration des modules Quill (barre d'outils)
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><BsPeople size={25} className='mr-2' />Modification du Groupe {originalGroupeData.nom}</h2>
                            <small>Administration des groupes d'utilisateur.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-groupe`}>Groupes</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Modification du Groupe {originalGroupeData.nom}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container-fluid">
                        {/* Row principale qui centre le contenu */}
                        <div className="row justify-content-center">
                            {/* Colonne avec des classes responsive */}
                            <div className="col-12 col-lg-8 mx-auto mt-5 mb-3">
                                <div className="ibox-content">
                                    <div className="hpanel">
                                        <div className="panel-body">
                                            <form className="m-t" role="form" onSubmit={handleSubmit} encType="multipart/form-data">
                                                {/* Formulaire pour le nom */}
                                                <div className="form-group">
                                                    <label>Nom*</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        required
                                                        name="nom"
                                                        value={groupeData.nom || ''}
                                                        onChange={(e) => setGroupeData({ ...groupeData, nom: e.target.value })}
                                                    />
                                                </div>

                                                {/* Formulaire pour la description avec Quill */}
                                                <div className="form-group">
                                                    <label>Description</label>
                                                    <ReactQuill
                                                        theme="snow"
                                                        value={groupeData.description || ''}
                                                        onChange={(value) => setGroupeData({ ...groupeData, description: value })}
                                                        modules={modules}
                                                        className="quill-editor"
                                                    />
                                                </div>

                                                {/* Sélecteur pour le statut */}
                                                <div className="form-group">
                                                    <label>Statut*</label>
                                                    <select
                                                        className="form-control m-b"
                                                        name="statut"
                                                        value={groupeData.statut || 'inactif'}
                                                        onChange={(e) => setGroupeData({ ...groupeData, statut: e.target.value })}
                                                    >
                                                        <option value="inactif">Inactif</option>
                                                        <option value="actif">Actif</option>
                                                    </select>
                                                </div>

                                                {/* Boutons d'action */}
                                                <div className="text-center mt-4">
                                                    <a href='/Liste-groupe' className="btn btn-default mr-2">Annuler</a>
                                                    <button type="button" className="btn btn-default mr-2" onClick={handleCancel}>Effacer</button>
                                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Modifier_groupe;
